import { Logo } from "../Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div>
            <Logo size={34} />
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500 max-w-xs leading-loose">
              Architects of Digital Dominance. Strategy, design and engineering under one roof.
            </p>
          </div>
          <div className="flex gap-16">
            <div className="space-y-3">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-volt">Studio</p>
              {["Services", "Work", "Process", "Contact"].map((l) => (
                <a key={l} href={`#${l.toLowerCase()}`} data-testid={`footer-link-${l.toLowerCase()}`} className="block text-sm text-slate-400 hover:text-volt transition-colors duration-300">
                  {l}
                </a>
              ))}
            </div>
            <div className="space-y-3">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-volt">Portal</p>
              <a href="/login" data-testid="footer-link-login" className="block text-sm text-slate-400 hover:text-volt transition-colors duration-300">Client Login</a>
              <a href="#contact" data-testid="footer-link-signup" className="block text-sm text-slate-400 hover:text-volt transition-colors duration-300">Request Access</a>
            </div>
          </div>
        </div>

        <h2 className="mt-20 font-display font-extrabold tracking-tighter leading-none text-[16vw] lg:text-[11rem] text-stroke select-none text-center" aria-hidden="true">
          ZORK MEDIA
        </h2>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">© 2026 Zork Media. All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600 flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-ticker" />
            All systems operational
          </p>
        </div>
      </div>
    </footer>
  );
}
